import styled from 'styled-components'
import { Button, Col } from 'react-angle-dashboard-components'

// FinalQuoteDetails

export const PDFSectionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 34px;
`

export const PDFSectionHeader = styled.span`
  font-size: 22px;
  font-weight: 600;
  margin-right: 35px;
`

export const PDFSectionText = styled.span`
  font-weight: 500;
  margin-right: 15px;
  font-size: 16px;
`

export const EditPlanLink = styled(Button)`
  font-weight: 600;
  display: block;
  padding-bottom: 30px;
  text-decoration: underline;
  margin: auto;
`

export const HeaderWrapper = styled.div`
  min-height: 130px;
  margin-left: 1px;

  padding: 20px 10px 10px 10px;
  text-align: center;
  background: var(--primary);
`

export const Header = styled.span`
  color: #fff;
  display: block;
  font-size: 45px;
  font-family: Sentinel;
`

// MainCostsSection

export const CostSubtext = styled.span`
  color: var(--primary);
  font-weight: 600;
  margin-left: 10px;
`

export const CostSubWrapper = styled.div`
  font-size: 20px;
`

export const RightCol = styled(Col)`
  padding: 48px 80px 48px 50px;
  border-left: 1px solid #dee2e6;
`

export const LeftCol = styled(Col)`
  padding: 48px 80px;
`

export const TotalCostText = styled.p`
  font-size: 45px;
  font-weight: 600;
  color: var(--primary);
`

// YourPlanDetails

export const PlanDetailsWrapper = styled.div`
  padding: 48px 85px;
  background: white;
`
export const ClickableText = styled.button`
  margin: 19px 39px;
  border: none;
  background: inherit;
`

export const EmployeePremiumsWrapper = styled.div`
  margin-top: 22px;
  border-radius: 6px;
  overflow-x: auto;
`
